import { render, staticRenderFns } from "./CourseReviewFlexCard.vue?vue&type=template&id=2ecf787d&"
import script from "./CourseReviewFlexCard.vue?vue&type=script&lang=ts&"
export * from "./CourseReviewFlexCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VSheet,VSpacer})
